import { z } from 'zod';
import { issue } from '@/lib/forms/messages';

/** The three properties the route inspects. A browser `File` satisfies it. */
const uploadedFile = z.object({
  name: z.string(),
  size: z.number(),
  type: z.string(),
});

/** An empty list rejects everything — callers must wait for `ready`, not validate against nothing. */
export const makeDocumentUploadFileSchema = (allowedMimeTypes: readonly string[]) =>
  // superRefine so the message can name the file; a field-level `error` cannot.
  uploadedFile.superRefine((file, ctx) => {
    // Windows/Excel registers .csv under the legacy Excel MIME. Only .csv
    // receives this alias; the backend applies the same normalization.
    const rawType = file.type.toLowerCase();
    const type = file.name.toLowerCase().endsWith('.csv') && rawType === 'application/vnd.ms-excel'
      ? 'text/csv' : rawType;
    if (!allowedMimeTypes.includes(type)) {
      ctx.addIssue(
        file.type
          ? issue('documents.uploadMimeNotAllowed', ['type'], {
            name: file.name,
            type: file.type,
          })
          : issue('documents.uploadMimeUnknown', ['type'], { name: file.name }),
      );
    }
  });

export type DocumentUploadFileSchema = ReturnType<typeof makeDocumentUploadFileSchema>;
